import { render, staticRenderFns } from "./ModalEventHistory.vue?vue&type=template&id=ec22401e&scoped=true&"
import script from "./ModalEventHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalEventHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEventHistory.vue?vue&type=style&index=0&id=ec22401e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec22401e",
  null
  
)

export default component.exports